import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { site } from "@/lib/siteContent";

export default function FinalCta() {
  const c = site.finalCta;
  return (
    <section
      id="contact"
      data-testid="cta-section"
      className="relative bg-navy-dark text-white py-28 lg:py-40 overflow-hidden"
    >
      {/* Decorative grid lines */}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: "linear-gradient(#D4AF37 1px, transparent 1px), linear-gradient(90deg, #D4AF37 1px, transparent 1px)",
          backgroundSize: "80px 80px"
        }} />
      </div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-gold/5 blur-3xl pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="text-center max-w-5xl mx-auto"
        >
          <div className="text-[11px] font-bold uppercase tracking-[0.32em] text-gold mb-8">
            {c.overline}
          </div>
          <h2 className="font-display font-medium text-5xl sm:text-6xl lg:text-[120px] leading-[0.95] tracking-tight">
            <span className="block">{c.headingLine1}</span>
            <span className="block text-gold italic">{c.headingLine2}</span>
            <span className="block">{c.headingLine3}</span>
          </h2>

          <p className="mt-12 text-white/70 text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
            {c.description}
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`mailto:${site.contact.emailGeneral}`}
              data-testid="final-cta-primary"
              className="group inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-navy px-8 py-4 text-xs font-bold uppercase tracking-[0.22em] transition-all duration-300 hover:translate-y-[-2px]"
            >
              {c.ctaPrimary}
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
            <a
              href="#people"
              data-testid="final-cta-secondary"
              className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-gold text-white hover:text-gold px-8 py-4 text-xs font-bold uppercase tracking-[0.22em] transition-all duration-300 hover:bg-white/5"
            >
              {c.ctaSecondary}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
